import { shopModuleForAdminPath } from '~/utils/shopModules'

export default defineNuxtRouteMiddleware(async (to) => {
  const key = shopModuleForAdminPath(to.path)
  if (!key) return

  const { fetchSettings } = useSiteSettings()
  const { isEnabled } = useShopModules()
  await fetchSettings()

  if (!isEnabled(key)) {
    return navigateTo(shopPathForRoute(to, '/admin/abonament'), { replace: true })
  }
})
